// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import React from 'react';
import { HelpPanel } from '@cloudscape-design/components';

/* eslint-disable react/jsx-key */
export default [
  <HelpPanel
    header={<h2>Architecture Details</h2>}
  >
<p>
  <strong>(1)</strong> The <a href="https://aws.amazon.com/iot-core/">M5Stack device</a> acts as a device gateway and securely sends sensor data to AWS IoT Core through MQTT.
</p>
<p>
  <strong>(2)</strong> <a href="https://aws.amazon.com/iot-core/">Rules for AWS IoT</a> allow your devices to interact with AWS services. Rules analyze the MQTT topic stream and perform actions accordingly.
</p>
<p>
  <strong>(3)</strong> Sensor metrics are aggregated, transformed, and stored in <a href="https://aws.amazon.com/dynamodb/">DynamoDB</a> to be consumed by <a href="https://aws.amazon.com/alexa/">Alexa</a> and <a href="https://aws.amazon.com/lex/">Amazon Lex</a>.
</p>
<p>
  <strong>(4)</strong> <a href="https://aws.amazon.com/iot-events/">AWS IoT Events</a> monitors your equipment or device fleet for failures or changes in operation and starts necessary actions, such as turning on a pump when moisture value drops below a certain threshold.
</p>
<p>
  <strong>(5)</strong> Another IoT rule sends sensor metrics to <a href="https://aws.amazon.com/iot-sitewise/">AWS IoT SiteWise</a>, which collects, organizes, and analyzes industrial equipment data at scale. The AWS IoT SiteWise portal displays metrics in real time.
</p>
<p>
  <strong>(6)</strong> A web application is hosted on <a href="https://aws.amazon.com/amplify/">Amazon Amplify</a>, which takes care of the backend and hosting by creating and maintaining resources like Amazon Cognito, Amazon CloudFront, and S3 Bucket.
</p>
<p>
  <strong>(7)</strong> The backend logic of the web application is implemented via <a href="https://aws.amazon.com/api-gateway/">Amazon API Gateway</a> and several <a href="https://aws.amazon.com/lambda/">Lambda</a> functions, which access data from DynamoDB or publish to IoT topics.
</p>
<p>
  <strong>(8)</strong> An <a href="https://aws.amazon.com/lambda/">AWS Lambda</a> function defines the Alexa skill logic. This Lambda function accesses sensor data from the DynamoDB table and sends data to an IoT topic to turn on the pump.
</p>
  </HelpPanel>,
];
/* eslint-enable react/jsx-key */
